import { type SummaryLine, summarizeChanges } from "@/lib/changeSummary";
import type { Slide } from "@/lib/types";

type Props = { before: Slide; after: Slide };

function iconFor(category: SummaryLine["category"]): string {
  switch (category) {
    case "text":
      return "💬";
    case "font":
      return "🔤";
    case "transform":
      return "📐";
    case "fill":
      return "🎨";
    case "line":
      return "✏️";
    case "shape-added":
      return "➕";
    case "shape-removed":
      return "➖";
    default:
      return "·";
  }
}

export function ChangeSummary({ before, after }: Props) {
  const lines = summarizeChanges(before, after);
  return (
    <div className="rounded-[14px] border border-[var(--color-border)] bg-[var(--color-surface)] p-5">
      <h4 className="mb-3 font-display text-sm font-medium uppercase tracking-wide text-[var(--color-ink-muted)]">
        AI が行った変更 ({lines.length})
      </h4>
      {lines.length === 0 ? (
        <p className="text-sm text-[var(--color-ink-muted)]">
          内容は変わっていないようです（タイポ修正や同義語の置き換えなど細かい違いはテキスト比較に反映されない可能性があります）。
        </p>
      ) : (
        <ul className="flex flex-col gap-1.5">
          {lines.map((l, i) => (
            <li
              key={`${l.shape ?? "-"}-${i}`}
              className="flex items-start gap-2 rounded-[8px] bg-[var(--color-surface-muted)] px-3 py-2 text-sm"
            >
              <span aria-hidden>{iconFor(l.category)}</span>
              <span className="break-words text-[var(--color-ink)]">{l.text}</span>
            </li>
          ))}
        </ul>
      )}
      <p className="mt-3 text-[11px] leading-snug text-[var(--color-ink-soft)]">
        これは JSON の差分からルールベースで自動生成した要約です（AI
        は呼び出していません）。細かな表現の違いは含みません。
      </p>
    </div>
  );
}
